export type PriceOrderKey = 'price_ascending' | 'price_descending';
type PriceDirection = 'asc' | 'desc';

/**
 * Maps a textual price order to its sort direction.
 *
 * @param order - Must be one of 'price_ascending' or 'price_descending'.
 * @returns The sort direction ('asc' or 'desc').
 */
export function filterPrice(order: PriceOrderKey): PriceDirection {
  const map: Record<PriceOrderKey, PriceDirection> = {
    price_ascending: 'asc',
    price_descending: 'desc',
  };

  return map[order];
}
